import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ContentService } from 'lion-api';
import { TranslateService } from '@ngx-translate/core';
import { HttpErrorResponse } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Base64 } from 'js-base64';

@Component({
  selector: 'app-helptext',
  templateUrl: './help-text.component.html',
  styleUrl: './help-text.component.scss',
  standalone: false
})
export class HelpTextComponent {
  dialogVisible = false;
  contentValue: SafeHtml | string | undefined;
  private route = inject(Router);
  private contentService = inject(ContentService);
  private translateService = inject(TranslateService);
  private sanitizer = inject(DomSanitizer);

  openHelpTextDialog() {
    const modifiedUrl = this.route.url.substring(1, this.route.url.length);
    this.contentService.contentTypeRouteGet('HILFE', modifiedUrl.split('/').join('___')).subscribe({
      next: (value) => {
        let content = value.contentHtml;
        if (content) {
          try {
            const cleanContent = content.replace(/\s+/g, '');
            const isBase64 = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)?$/.test(cleanContent);

            if (isBase64 && cleanContent.length > 0) {
              const decoded = Base64.decode(cleanContent);
              const bytes = new Uint8Array(decoded.length);
              for (let i = 0; i < decoded.length; i++) {
                bytes[i] = decoded.charCodeAt(i);
              }
              content = new TextDecoder('utf-8').decode(bytes);
            }
          } catch {
            console.info('Help text ist not base64 encoded.');
          }
        }

        if (content) {
          this.contentValue = this.sanitizer.bypassSecurityTrustHtml(content);
        } else {
          this.contentValue = undefined;
        }

        this.dialogVisible = true;
        if (!this.contentValue) {
          this.contentValue = this.translateService.instant('help.helptextError');
        }
      },
      error: (error: HttpErrorResponse) => {
        if (error.status === 404) {
          this.contentValue = this.translateService.instant('help.helptextError');
          this.dialogVisible = true;
        } else {
          console.error(error);
        }
      }
    });
  }
}
